/* eslint-disable no-useless-escape */
/* eslint-disable  */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
// React Components
import { Link } from "react-router-dom";
/* eslint-disable */
import React, { useState, useEffect } from "react";
import UserInfo from "../UserInfo";
import noImg from "../../assets/images/no-image.svg";

// material ui
import { Badge, IconButton } from "@material-ui/core";
import ReceiptIcon from "@mui/icons-material/Receipt";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

// redux
import { useSelector, useDispatch } from "react-redux";

import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../redux-store/store";
import { withTranslation, useTranslation } from "react-i18next";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Fastfood } from "@mui/icons-material";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

const HomeBanner = ({ image, branchIsLoading }) => {
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();  
  const { t } = useTranslation();
  const { setLangValue } = bindActionCreators(
    actionCreators,
    appDispatch
  );

  const matches = useMediaQuery("(min-width:600px)");
  const [formData, setFormData] = useState(
    JSON.parse(localStorage.getItem("formData")) !== null
      ? JSON.parse(localStorage.getItem("formData"))
      : {}
  );

  const [open, setOpen] = useState(false);

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    const scrolling = () => {
      const handleScroll = () => {
        setScroll(window.scrollY > 0);
      };

      window.addEventListener("scroll", handleScroll);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };

    scrolling();
  }, []);

  const handleClickOpen = () => {
    // console.log("consoling");

    appDispatch({ type: "setLoginModal", loginModal: true });
    // var shop_url = window.location.href
    // var auth_url = `${process.env.REACT_APP_AUTH_URL}`
    // setCookie(`redirect`, shop_url);
    // window.location.replace(auth_url);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const arLanguageHandle = (e) => {
    // console.log("ar change");
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
  };
  const enLanguageHandle = (e) => {
    // console.log("en change");

    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };
  const handleLange = (lang) => {
    setLangValue(lang);
  };

  // Function to check if the cover is a video file
  const isVideoFile = (url) => {
    if (!url) return false;
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv'];
    const lowerUrl = url.toLowerCase();
    return videoExtensions.some(ext => lowerUrl.includes(ext));
  };

  // Function to check if the cover is an image file
  const isImageFile = (url) => {
    if (!url) return false;
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
    const lowerUrl = url.toLowerCase();
    return imageExtensions.some(ext => lowerUrl.includes(ext));
  };

  return (
    <div className="storeBanner">
      {/* <LoginDialog
        open={open}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
      />
      <LoginModal closeBtn={true} /> */}

      {appState.storeInfo.cover && !branchIsLoading ? (
        isVideoFile(appState.storeInfo.cover) ? (
          <div className="video-container">
            <video className="responsive-video" autoPlay muted loop playsInline>
              <source src={appState.storeInfo.cover} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ) : (
          <img
            src={appState.storeInfo.cover}
            alt=""
          />
        )
      ) : (
        <img
          src={noImg}
          alt=""
        />
      )}
      <div className={scroll > 0 ? `top_nav_bar_scroll` : `top_nav_bar`}>
        {appState.payTableMode ? (
          <div className="row m-0 searhIcon">
            <div className="d-flex align-items-center px-1 col-4">
              <IconButton
                aria-label="back"
                onClick={() =>
                  appDispatch({
                    type: "setPayTablePopUp",
                    payTablePopUp: true,
                  })
                }
                className={`backBtn ${
                  appState.langValue === "ar" ? "backBtnAr" : ""
                }`}
              >
                {appState.langValue == "ar" ? (
                  <ArrowForwardIosIcon
                    style={{ padding: 0 }}
                    fontSize="inherit"
                  />
                ) : (
                  <ArrowBackIosIcon fontSize="inherit" />
                )}
              </IconButton>
            </div>

            <div className="col-6 d-flex justify-content-end">
              {appState.langValue == "ar" ? (
                <IconButton id="headerBtn" onClick={(e) => setLangValue("en")}>
                  <span
                    className={
                      scroll > 0 ? `lang-textScroll p-0 ` : `lang-text p-0`
                    }
                  >
                    EN
                  </span>
                </IconButton>
              ) : (
                <IconButton
                  id="headerBtn"
                  onClick={(e) => setLangValue("ar")}
                  className="arabicBtn"
                >
                  <span
                    className={`arabicText ${
                      scroll > 0 ? `lang-textScroll p-0 ` : `lang-text `
                    }`}
                  >
                    عربي{" "}
                  </span>
                </IconButton>
              )}
            {(appState.storeInfo?.chinessLanguage ) && (
                <IconButton id="headerBtn" onClick={() => handleLange(appState.langValue == "ch" ? "en" : "ch")}>
                  <span
                    className={
                      scroll > 0 ? `lang-textScroll p-0 ` : `lang-text p-0`
                    }
                  >
                    {appState.langValue == "ch" ? "EN" : "CH"}
                  </span>
                </IconButton>
              )}
              <IconButton
                component={Link}
                to="/search"
                className="classForSvgColor mt-1"
                id="headerBtn"
              >
                {/* <SearchIcon fontSize="inherit" /> */}
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 2.25C6.16751 2.25 2.25 6.16751 2.25 11C2.25 15.8325 6.16751 19.75 11 19.75C13.1462 19.75 15.112 18.9773 16.6342 17.6949L19.4697 20.5303C19.7626 20.8232 20.2374 20.8232 20.5303 20.5303C20.8232 20.2374 20.8232 19.7626 20.5303 19.4697L17.6949 16.6342C18.9773 15.112 19.75 13.1462 19.75 11C19.75 6.16751 15.8325 2.25 11 2.25ZM3.75 11C3.75 6.99594 6.99594 3.75 11 3.75C15.0041 3.75 18.25 6.99594 18.25 11C18.25 15.0041 15.0041 18.25 11 18.25C6.99594 18.25 3.75 15.0041 3.75 11Z"
                    fill="#fff"
                  />
                </svg>
              </IconButton>




              {
              // appState.formData.openBill &&
               (appState.formData?.order_invoice == "open_bill"&&
              appState.qrBranch &&
              appState.loggedIn &&
              !appState.hotelQrCode &&
              !appState.payTableMode) ? (
                <IconButton component={Link} to="/openOrder" id="headerBtn">
                  <ReceiptIcon fontSize="inherit" />
                </IconButton>
              ) : (
                ""
              )}
            
              {appState.qrBranch ? (
                <span>
                  {!appState.loggedIn ? (
                    <IconButton
                      className="signInBtn"
                      onClick={handleClickOpen}
                      id="headerBtn"
                    >
                      <i className="fa fa-user"></i>
                    </IconButton>
                  ) : (
                    <UserInfo />
                  )}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="row m-0 searhIcon">
            <div className="d-flex align-items-center px-1 col-4">
              {appState.langValue == "ar" ? (
                <IconButton id="headerBtn" onClick={(e) => setLangValue("en")}>
                  <span
                    className={
                      scroll > 0 ? `lang-textScroll p-0 ` : `lang-text p-0`
                    }
                  >
                    EN
                  </span>
                </IconButton>
              ) : (
                <IconButton
                  id="headerBtn"
                  onClick={(e) => setLangValue("ar")}
                  className="arabicBtn"
                >
                  <span
                    className={`arabicText ${
                      scroll > 0 ? `lang-textScroll p-0 ` : `lang-text `
                    }`}
                  >
                    عربي{" "}
                  </span>
                </IconButton>
              )}
              {(appState.storeInfo?.chinessLanguage ) && (
                <IconButton id="headerBtn" onClick={() => handleLange(appState.langValue == "ch" ? "en" : "ch")}>
                  <span
                    className={
                      scroll > 0 ? `lang-textScroll p-0 ` : `lang-text p-0`
                    }
                  >
                    {appState.langValue == "ch" ? "EN" : "CH"}
                  </span>
                </IconButton>
              )}
              <IconButton
                component={Link}
                to="/search"
                className="classForSvgColor"
                id="headerBtn"
              >
                {/* <SearchIcon fontSize="inherit" /> */}
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 2.25C6.16751 2.25 2.25 6.16751 2.25 11C2.25 15.8325 6.16751 19.75 11 19.75C13.1462 19.75 15.112 18.9773 16.6342 17.6949L19.4697 20.5303C19.7626 20.8232 20.2374 20.8232 20.5303 20.5303C20.8232 20.2374 20.8232 19.7626 20.5303 19.4697L17.6949 16.6342C18.9773 15.112 19.75 13.1462 19.75 11C19.75 6.16751 15.8325 2.25 11 2.25ZM3.75 11C3.75 6.99594 6.99594 3.75 11 3.75C15.0041 3.75 18.25 6.99594 18.25 11C18.25 15.0041 15.0041 18.25 11 18.25C6.99594 18.25 3.75 15.0041 3.75 11Z"
                    fill="#fff"
                  />
                </svg>
              </IconButton>

              {appState.showTagsAndDitesFilter &&
              (appState.tags.length > 0 || appState.dietaries.length > 0) ? (
                <IconButton
                  onClick={() =>
                    appDispatch({
                      type: "setFilterProductMode",
                      filterProductMode: true,
                    })
                  }
                  component={Link}
                  to="/"
                  id="headerBtn"
                  className="classForSvgColor"
                >
                  <FilterListIcon  fontSize="inherit" />
                </IconButton>
              ) : (
                ""
              )}

              {/* working */}

              {/* {appState.tags.length > 0 || appState.dietaries.length > 0 ? (
                <IconButton
                  onClick={() =>
                    appDispatch({
                      type: "setLoyalityPopupMode",
                      loyalityPopupMode: true,
                    })
                  }
                  component={Link}
                  to="/"
                  id="headerBtn"
                >
                  <FilterListIcon fontSize="inherit" />
                </IconButton>
              ) : (
                ""
              )} */}

                {!appState.payTableMode && appState.qrBranch && (
                  <IconButton
                    className="classForSvgColor"
                    component={Link}
                    to="/cart"
                    id="headerBtn"
                  >
                    {appState.cart.length !== 0 ? (
                      <Badge
                        badgeContent={appState.cart.length}
                        color="primary"
                        overlap="rectangular"
                      >
                        {/* <i className="fa fa-shopping-cart" ></i> */}
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1.50007 2.75C1.78476 2.75001 1.88363 2.75062 1.96779 2.75751C2.81868 2.82715 3.55687 3.37236 3.87364 4.16516C3.90498 4.24358 3.93463 4.3379 4.01838 4.61008L5.99316 11.0281C6.29594 12.0122 6.54213 12.8124 6.81597 13.4359C7.10167 14.0864 7.44679 14.6169 7.98784 15.0165C8.52889 15.4161 9.13745 15.59 9.84321 15.6717C10.5197 15.7501 11.3569 15.7501 12.3865 15.7501H14.581C15.6178 15.7501 16.4607 15.7501 17.1414 15.6709C17.8515 15.5883 18.4635 15.4126 19.0064 15.0087C19.5493 14.6047 19.8934 14.069 20.1766 13.4126C20.4481 12.7834 20.6902 11.9761 20.9881 10.983L21.1909 10.3072C21.5299 9.17741 21.8081 8.2499 21.918 7.50536C22.0325 6.72982 21.9907 5.99351 21.5182 5.35851C21.0458 4.7235 20.3525 4.47191 19.5768 4.35869C18.8321 4.25001 17.8638 4.25003 16.6842 4.25006L5.5 4.25006C5.49234 4.25006 5.48471 4.25018 5.47711 4.25041L5.44241 4.13763C5.37194 3.90851 5.32359 3.7513 5.26657 3.60859C4.73861 2.28727 3.5083 1.37857 2.09014 1.26251C1.93697 1.24997 1.77251 1.24998 1.53278 1.25L1.50002 1.25L0.999908 1.25006C0.585695 1.25011 0.249949 1.58594 0.25 2.00016C0.250051 2.41437 0.585878 2.75011 1.00009 2.75006L1.50007 2.75ZM7.41361 10.544L5.93855 5.75006H16.6239C17.8788 5.75006 18.7367 5.75197 19.3602 5.84297C19.9654 5.93129 20.1875 6.08276 20.3148 6.2539C20.4421 6.42504 20.5234 6.68131 20.4341 7.28634C20.3421 7.90972 20.0974 8.7319 19.7368 9.93394L19.5644 10.5086C19.2504 11.5555 19.0322 12.2787 18.7993 12.8185C18.5742 13.3402 18.3653 13.616 18.111 13.8052C17.8567 13.9944 17.5325 14.1153 16.9681 14.1809C16.3841 14.2489 15.6287 14.2501 14.5358 14.2501H12.4314C11.346 14.2501 10.596 14.2489 10.0158 14.1817C9.45511 14.1167 9.13249 13.9972 8.87899 13.8099C8.6255 13.6227 8.41633 13.3495 8.18936 12.8327C7.95451 12.298 7.73281 11.5814 7.41361 10.544Z"
                            fill="#fff"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.25 20C7.25 18.4812 8.48122 17.25 10 17.25C11.5188 17.25 12.75 18.4812 12.75 20C12.75 21.5188 11.5188 22.75 10 22.75C8.48122 22.75 7.25 21.5188 7.25 20ZM10 18.75C9.30964 18.75 8.75 19.3096 8.75 20C8.75 20.6904 9.30964 21.25 10 21.25C10.6904 21.25 11.25 20.6904 11.25 20C11.25 19.3096 10.6904 18.75 10 18.75Z"
                            fill="#fff"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.25 20C15.25 18.4812 16.4812 17.25 18 17.25C19.5188 17.25 20.75 18.4812 20.75 20C20.75 21.5188 19.5188 22.75 18 22.75C16.4812 22.75 15.25 21.5188 15.25 20ZM18 18.75C17.3096 18.75 16.75 19.3096 16.75 20C16.75 20.6904 17.3096 21.25 18 21.25C18.6904 21.25 19.25 20.6904 19.25 20C19.25 19.3096 18.6904 18.75 18 18.75Z"
                            fill="#fff"
                          />
                        </svg>
                      </Badge>
                    ) : (
                      ""
                    )}
                  </IconButton>
                )}

              {appState.serviceMode.includes("share-bill") &&
                appState.formData.openBill &&
                appState.qrBranch &&
                // appState.loggedIn &&
                !appState.hotelQrCode &&
                !appState.payTableMode && (
                  <IconButton
                    id="headerBtn"
                    className="classForSvgColor"
                    onClick={() =>
                      appDispatch({
                        type: "setShareBillPopup",
                        shareBillPopup: true,
                        shareBillUrl: appState.shareBillUrl,
                      })
                    }
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 8C1.45 8 0.979 7.804 0.587 7.412C0.195667 7.02067 0 6.55 0 6V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H6C6.55 0 7.021 0.195667 7.413 0.587C7.80433 0.979 8 1.45 8 2V6C8 6.55 7.80433 7.02067 7.413 7.412C7.021 7.804 6.55 8 6 8H2ZM2 6H6V2H2V6ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V12C0 11.45 0.195667 10.979 0.587 10.587C0.979 10.1957 1.45 10 2 10H6C6.55 10 7.021 10.1957 7.413 10.587C7.80433 10.979 8 11.45 8 12V16C8 16.55 7.80433 17.021 7.413 17.413C7.021 17.8043 6.55 18 6 18H2ZM2 16H6V12H2V16ZM12 8C11.45 8 10.9793 7.804 10.588 7.412C10.196 7.02067 10 6.55 10 6V2C10 1.45 10.196 0.979 10.588 0.587C10.9793 0.195667 11.45 0 12 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V6C18 6.55 17.8043 7.02067 17.413 7.412C17.021 7.804 16.55 8 16 8H12ZM12 6H16V2H12V6ZM16.5 18C16.3667 18 16.25 17.95 16.15 17.85C16.05 17.75 16 17.6333 16 17.5V16.5C16 16.3667 16.05 16.25 16.15 16.15C16.25 16.05 16.3667 16 16.5 16H17.5C17.6333 16 17.75 16.05 17.85 16.15C17.95 16.25 18 16.3667 18 16.5V17.5C18 17.6333 17.95 17.75 17.85 17.85C17.75 17.95 17.6333 18 17.5 18H16.5ZM10.5 12C10.3667 12 10.25 11.95 10.15 11.85C10.05 11.75 10 11.6333 10 11.5V10.5C10 10.3667 10.05 10.25 10.15 10.15C10.25 10.05 10.3667 10 10.5 10H11.5C11.6333 10 11.75 10.05 11.85 10.15C11.95 10.25 12 10.3667 12 10.5V11.5C12 11.6333 11.95 11.75 11.85 11.85C11.75 11.95 11.6333 12 11.5 12H10.5ZM12.5 14C12.3667 14 12.25 13.95 12.15 13.85C12.05 13.75 12 13.6333 12 13.5V12.5C12 12.3667 12.05 12.25 12.15 12.15C12.25 12.05 12.3667 12 12.5 12H13.5C13.6333 12 13.75 12.05 13.85 12.15C13.95 12.25 14 12.3667 14 12.5V13.5C14 13.6333 13.95 13.75 13.85 13.85C13.75 13.95 13.6333 14 13.5 14H12.5ZM10.5 16C10.3667 16 10.25 15.95 10.15 15.85C10.05 15.75 10 15.6333 10 15.5V14.5C10 14.3667 10.05 14.25 10.15 14.15C10.25 14.05 10.3667 14 10.5 14H11.5C11.6333 14 11.75 14.05 11.85 14.15C11.95 14.25 12 14.3667 12 14.5V15.5C12 15.6333 11.95 15.75 11.85 15.85C11.75 15.95 11.6333 16 11.5 16H10.5ZM12.5 18C12.3667 18 12.25 17.95 12.15 17.85C12.05 17.75 12 17.6333 12 17.5V16.5C12 16.3667 12.05 16.25 12.15 16.15C12.25 16.05 12.3667 16 12.5 16H13.5C13.6333 16 13.75 16.05 13.85 16.15C13.95 16.25 14 16.3667 14 16.5V17.5C14 17.6333 13.95 17.75 13.85 17.85C13.75 17.95 13.6333 18 13.5 18H12.5ZM14.5 16C14.3667 16 14.25 15.95 14.15 15.85C14.05 15.75 14 15.6333 14 15.5V14.5C14 14.3667 14.05 14.25 14.15 14.15C14.25 14.05 14.3667 14 14.5 14H15.5C15.6333 14 15.75 14.05 15.85 14.15C15.95 14.25 16 14.3667 16 14.5V15.5C16 15.6333 15.95 15.75 15.85 15.85C15.75 15.95 15.6333 16 15.5 16H14.5ZM14.5 12C14.3667 12 14.25 11.95 14.15 11.85C14.05 11.75 14 11.6333 14 11.5V10.5C14 10.3667 14.05 10.25 14.15 10.15C14.25 10.05 14.3667 10 14.5 10H15.5C15.6333 10 15.75 10.05 15.85 10.15C15.95 10.25 16 10.3667 16 10.5V11.5C16 11.6333 15.95 11.75 15.85 11.85C15.75 11.95 15.6333 12 15.5 12H14.5ZM16.5 14C16.3667 14 16.25 13.95 16.15 13.85C16.05 13.75 16 13.6333 16 13.5V12.5C16 12.3667 16.05 12.25 16.15 12.15C16.25 12.05 16.3667 12 16.5 12H17.5C17.6333 12 17.75 12.05 17.85 12.15C17.95 12.25 18 12.3667 18 12.5V13.5C18 13.6333 17.95 13.75 17.85 13.85C17.75 13.95 17.6333 14 17.5 14H16.5Z"
                        fill="#fff"
                      />
                    </svg>
                  </IconButton>
                )}
              {appState.formData?.order_invoice == "open_bill"&&
              appState.qrBranch &&
              appState.loggedIn &&
              !appState.hotelQrCode &&
              !appState.payTableMode? (
                <IconButton
                  component={Link}
                  className="classForSvgColor mb-1"
                  to="/openOrder"
                  id="headerBtn"
                >
                  <span>
                    <div className="ring-container-open-bill">
                      <div className="ringring"></div>
                      <div className="circle"></div>
                    </div>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.25 7C4.25 6.58579 4.58579 6.25 5 6.25H9C9.41421 6.25 9.75 6.58579 9.75 7C9.75 7.41421 9.41421 7.75 9 7.75H5C4.58579 7.75 4.25 7.41421 4.25 7Z"
                        fill="#fff"
                      />
                      <path
                        d="M5 10.25C4.58579 10.25 4.25 10.5858 4.25 11C4.25 11.4142 4.58579 11.75 5 11.75H11C11.4142 11.75 11.75 11.4142 11.75 11C11.75 10.5858 11.4142 10.25 11 10.25H5Z"
                        fill="#fff"
                      />
                      <path
                        d="M4.25 15C4.25 14.5858 4.58579 14.25 5 14.25H11C11.4142 14.25 11.75 14.5858 11.75 15C11.75 15.4142 11.4142 15.75 11 15.75H5C4.58579 15.75 4.25 15.4142 4.25 15Z"
                        fill="#fff"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.623556 0.351317C0.854792 0.217126 1.13998 0.216174 1.37211 0.348818L4.5 2.13619L7.6279 0.348818C7.85847 0.217061 8.14153 0.217061 8.37211 0.348818L11.5 2.13619L14.6279 0.348818C14.86 0.216174 15.1452 0.217126 15.3764 0.351317C15.6077 0.485509 15.75 0.732647 15.75 1V9.25H19C19.4142 9.25 19.75 9.58579 19.75 10V17C19.75 18.5188 18.5188 19.75 17 19.75H6.94513C5.57754 19.75 4.47522 19.75 3.60825 19.6335C2.70814 19.5125 1.95027 19.2536 1.34835 18.6517C0.746434 18.0497 0.48754 17.2919 0.366524 16.3918C0.249963 15.5248 0.24998 14.4225 0.250001 13.0549V1C0.250001 0.732647 0.39232 0.485509 0.623556 0.351317ZM17 18.25C17.6904 18.25 18.25 17.6904 18.25 17V10.75H15.75V17C15.75 17.6904 16.3096 18.25 17 18.25ZM14.5499 18.25H7C5.56459 18.25 4.56347 18.2484 3.80812 18.1469C3.07435 18.0482 2.68577 17.8678 2.40901 17.591C2.13225 17.3142 1.9518 16.9257 1.85315 16.1919C1.75159 15.4365 1.75 14.4354 1.75 13V2.29238L4.1279 3.65118C4.35847 3.78294 4.64153 3.78294 4.87211 3.65118L8 1.86381L11.1279 3.65118C11.3585 3.78294 11.6415 3.78294 11.8721 3.65118L14.25 2.29239V17C14.25 17.4501 14.3581 17.875 14.5499 18.25Z"
                        fill="#fff"
                      />
                    </svg>
                  </span>
                </IconButton>
              ) : (
                ""
              )}
            </div>
            {/* {matches ? (
              <div className="busniessName col-4 d-flex justify-content-center">
                {scroll > 0
                  ? get_lang(
                      get_lang(
                        appState.storeInfo.businessName,
                        appState.langValue
                      ),
                      appState.langValue
                    )
                  : ""}
              </div>
            ) : (
              ""
            )} */}

            <div className=" d-flex justify-content-end">
            {/* {appState.pickupOrDelivery == "pickup" ? (
                    <div className="d-flex align-items-center">
                      <h6 className="text-muted d-flex align-items-center">
                       <strong>{t("Pickup")}</strong> <span className="me-2"><Fastfood /></span> 
                      </h6>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <h6 className="text-muted d-flex align-items-center">
                      <strong >{t("Delivery")}</strong> <span className="me-2"><DeliveryDiningIcon /></span> 
                      </h6>
                    </div>
                  )} */}


              {!appState.loggedIn ? (
                <IconButton
                  className="signInBtn classForSvgColor"
                  onClick={handleClickOpen}
                  id="headerBtn"
                >
                  {/* <i className="fa fa-user"></i> */}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 2.25C9.37665 2.25 7.25 4.37665 7.25 7C7.25 9.62335 9.37665 11.75 12 11.75C14.6234 11.75 16.75 9.62335 16.75 7C16.75 4.37665 14.6234 2.25 12 2.25ZM8.75 7C8.75 5.20507 10.2051 3.75 12 3.75C13.7949 3.75 15.25 5.20507 15.25 7C15.25 8.79493 13.7949 10.25 12 10.25C10.2051 10.25 8.75 8.79493 8.75 7Z"
                      fill="#fff"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9 14.25C6.37665 14.25 4.25 16.3766 4.25 19C4.25 20.5188 5.48122 21.75 7 21.75H17C18.5188 21.75 19.75 20.5188 19.75 19C19.75 16.3766 17.6234 14.25 15 14.25H9ZM5.75 19C5.75 17.2051 7.20507 15.75 9 15.75H15C16.7949 15.75 18.25 17.2051 18.25 19C18.25 19.6904 17.6904 20.25 17 20.25H7C6.30964 20.25 5.75 19.6904 5.75 19Z"
                      fill="#fff"
                    />
                  </svg>
                </IconButton>
              ) : (
                <UserInfo />
              )}
            </div>
          </div>
        )}
      </div>
      </div>
  );
};

  export default withTranslation()(HomeBanner);
